import { useEffect, useState } from 'react';
import { TbAlertTriangle, TbRotate2 } from 'react-icons/tb';
import RModal from '../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomCheckBox } from '../../../../components/CustomCheckBox';
import * as S from './styles';

export const ConfirmActivateModal = ({
  pendingActivation,
  currentActive,
  onClose,
  onConfirm,
}) => {
  const [resetProgress, setResetProgress] = useState(false);

  useEffect(() => {
    setResetProgress(false);
  }, [pendingActivation]);

  return (
    <RModal
      open={Boolean(pendingActivation)}
      onClose={onClose}
      title={<ModalTitle />}
      bodyWidth="420px"
      footer={
        <>
          <CustomButton
            onClick={() => onConfirm(resetProgress)}
            appearance="primary"
          >
            Ativar
          </CustomButton>
          <CustomButton onClick={onClose} appearance="ghost">
            Cancelar
          </CustomButton>
        </>
      }
    >
      <ConfirmActivateMessage
        currentActive={currentActive}
        resetProgress={resetProgress}
        onChangeResetProgress={setResetProgress}
      />
    </RModal>
  );
};

const ModalTitle = () => {
  return (
    <S.TitleWrapper>
      <S.TitleIconWrap>
        <TbAlertTriangle size={18} />
      </S.TitleIconWrap>
      <S.TitleText>Ativar programa de fidelidade</S.TitleText>
    </S.TitleWrapper>
  );
};

const ConfirmActivateMessage = ({
  currentActive,
  resetProgress,
  onChangeResetProgress,
}) => {
  const nomeAtual = currentActive?.Nome;

  return (
    <S.MessageWrapper>
      <S.MainText>
        Isso vai desativar a fidelidade atualmente ativa
        {nomeAtual ? <S.ProgramName> "{nomeAtual}"</S.ProgramName> : ' atual'}.
        Os clientes param de acumular progresso nela a partir de agora.
      </S.MainText>

      {currentActive && (
        <S.ResetCard
          $active={resetProgress}
          onClick={() => onChangeResetProgress(!resetProgress)}
        >
          <S.ResetIconWrap $spin={resetProgress}>
            <TbRotate2 size={15} />
          </S.ResetIconWrap>

          <S.ResetTextCol>
            <S.ResetTitle>
              Zerar benefícios e progresso dos clientes
            </S.ResetTitle>
            <S.ResetDescription>
              Apaga também o que os clientes já acumularam
              {nomeAtual ? ` em "${nomeAtual}"` : ''} quantidade de pedidos,
              valor acumulado e saldo de cashback.{' '}
              <S.ResetDescriptionStrong>
                Essa ação não pode ser desfeita.
              </S.ResetDescriptionStrong>
            </S.ResetDescription>
          </S.ResetTextCol>
        </S.ResetCard>
      )}

      <S.ConfirmText>Deseja continuar?</S.ConfirmText>
    </S.MessageWrapper>
  );
};
